import { Button, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Container } from '../components';

const ValidationEmailSent = () => {
  const { t } = useTranslation(),
    navigate = useNavigate();

  return (
    <Container>
      <Col noFlex centerAll wid="100%">
        <Row wid="132px" ht="132px" bg={theme.GREEN} hasRadius="132px" centerAll marg="48px 0 0">
          <Icon type="markEmailread" dimensions={52} />
        </Row>

        <Text h1 marg="32px 0 0">
          {t('auth.validationEmailSent')}
        </Text>

        <Text b1 marg="8px 0 0" col={theme.GREY_60} center>
          {t('auth.checkInboxToValidateEmail')}
        </Text>

        <Button
          marg="32px 0 0"
          wid="296px"
          app
          onClick={() => navigate('/login')}
          text={`${t('auth.backTo')} ${t('auth.logIn')}`}
        />
      </Col>
    </Container>
  );
};

export default ValidationEmailSent;
